import type {FavouriteProductId} from '@/src/features/favourite/core/types'

/**
 * Favourite Store Interface
 *
 * Abstraction for the favourite products store.
 * Used for dependency injection and testability.
 */
export interface FavouriteStoreInterface {
  /**
   * Whether an operation is in progress
   */
  readonly pending: boolean

  /**
   * List of favourite product IDs
   */
  readonly favouriteIds: FavouriteProductId[]

  /**
   * Load favourites from storage
   */
  load(): Promise<void>

  /**
   * Check if a product is in favourites
   */
  is(id: Id): boolean

  /**
   * Toggle favourite status for a product
   * Adds if not in favourites, removes if already in
   */
  toggle(id: Id): Promise<void>
}

export const FavouriteStoreInterfaceSymbol = Symbol.for('FavouriteStoreInterface')
